module.exports = __webpack_public_path__ + "images/emoji/horse_racing.afeaf1238dedfa8c2529.png";